/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IPromoBannerCloseButton {
    closeButtonAriaLabel?: string;
    label?: string;
    telemetryContent?: ITelemetryContent;
    onClose(): void;

}

export const PromoBannerCloseButton: React.FC<IPromoBannerCloseButton> = ({ closeButtonAriaLabel, label, telemetryContent, onClose }) => {
    const payLoad = getPayloadObject('click', telemetryContent!, TelemetryConstant.PromoBannerClose);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    return (
        <button
            className='ms-promo-banner__close-button' aria-label={closeButtonAriaLabel} onClick={onClose}
            {...attributes}>
            <span className='ms-promo-banner__close-button__label' aria-hidden>
                {label}
            </span>
        </button>
    );
};
